module.exports = __webpack_public_path__ + "img/empty02.10c088f3.png";